import { observer } from "mobx-react";
import { Grid } from "@mui/material";
import React from "react";
import AcxEmptyState from "components/UI/AcxEmptyStateIndicator/AcxEmptyState";

const DashboardLoading = observer(() => {
    // TODO - create loading skeleton dashboard, also add skeletons to the sidebar for loading
    return (
        <Grid container height={"100%"}>
            <AcxEmptyState size="large" variant="loading" />
        </Grid>
    );
});

export default DashboardLoading;
